import { startApp } from "./app/index.tsx";

const date = new Date(Date.parse(APP_BUILD_TIME));

// format the date to the best format (YYYY-MM-DD HH:MM)
function formatDate(date) {
  return (
    date.toISOString().split("T")[0] +
    " " +
    date.toTimeString().split(" ")[0].split(":").slice(0, 2).join(":")
  );
}

console.log(`App version ${APP_VERSION}, built ${formatDate(date)}`);

startApp();
